"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactContentLoader = require("react-content-loader");

var _reactContentLoader2 = _interopRequireDefault(_reactContentLoader);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Name component. Show name and relevant SKU information of the Product Summary
 */


var ProductName = /*#__PURE__*/function (_Component) {
  _inherits(ProductName, _Component);

  function ProductName() {
    _classCallCheck(this, ProductName);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductName).apply(this, arguments));
  }

  _createClass(ProductName, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          productReferenceClass = _this$props.productReferenceClass,
          brandNameClass = _this$props.brandNameClass,
          skuNameClass = _this$props.skuNameClass,
          loaderClass = _this$props.loaderClass,
          className = _this$props.className,
          name = _this$props.name,
          styles = _this$props.styles,
          skuName = _this$props.skuName,
          showSku = _this$props.showSku,
          brandName = _this$props.brandName,
          showBrandName = _this$props.showBrandName,
          productReference = _this$props.productReference,
          showProductReference = _this$props.showProductReference;

      if (!name) {
        return _react2["default"].createElement(ProductName.Loader, _extends({
          className: loaderClass
        }, styles));
      }

      return _react2["default"].createElement("div", {
        className: (0, _classnames2["default"])('vtex-product-name', className)
      }, _react2["default"].createElement("span", {
        className: (0, _classnames2["default"])('vtex-product-name__brand', brandNameClass)
      }, name, " ", showBrandName && brandName && "- ".concat(brandName)), showSku && skuName && _react2["default"].createElement("span", {
        className: (0, _classnames2["default"])('vtex-product-name__sku', skuNameClass)
      }, skuName), showProductReference && productReference && _react2["default"].createElement("span", {
        className: (0, _classnames2["default"])('vtex-product-name__product-reference', productReferenceClass)
      }, "REF: ".concat(productReference)));
    }
  }]);

  return ProductName;
}(_react.Component);

_defineProperty(ProductName, "propTypes", {
  /** Name of the product */
  name: _propTypes2["default"].string,

  /** Selected SKU name */
  skuName: _propTypes2["default"].string,

  /** Show sku */
  showSku: _propTypes2["default"].bool,

  /** Product reference */
  productReference: _propTypes2["default"].string,

  /** Show product reference */
  showProductReference: _propTypes2["default"].bool,

  /** Brand name */
  brandName: _propTypes2["default"].string,

  /** Show brand name */
  showBrandName: _propTypes2["default"].bool,

  /** Component and content loader styles */
  styles: _propTypes2["default"].object,

  /** Classes to be applied to root element */
  className: _propTypes2["default"].string,

  /** Classes to be applied to brandName element */
  brandNameClass: _propTypes2["default"].string,

  /** Classes to be applied to skuName element */
  skuNameClass: _propTypes2["default"].string,

  /** Classes to be applied to productReference element */
  productReferenceClass: _propTypes2["default"].string,

  /** Classes to be applied to loader root element */
  loaderClass: _propTypes2["default"].string
});

_defineProperty(ProductName, "defaultProps", {
  showBrandName: false,
  showProductReference: false,
  showSku: false
});

_defineProperty(ProductName, "Loader", function () {
  var loaderProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react2["default"].createElement("div", {
    className: (0, _classnames2["default"])('vtex-product-name vtex-product-name-loader', loaderProps.className)
  }, _react2["default"].createElement(_reactContentLoader2["default"], _extends({
    style: {
      width: '100%',
      height: '100%'
    },
    width: 456,
    height: 100,
    preserveAspectRatio: "xMinYMin meet"
  }, loaderProps), _react2["default"].createElement("rect", _extends({
    height: "1.125em",
    width: "75%",
    x: "15%"
  }, loaderProps['vtex-product-name__brand--loader'])), _react2["default"].createElement("rect", _extends({
    height: "1.125em",
    width: "50%",
    x: "25%",
    y: "1.75em"
  }, loaderProps['vtex-product-name__sku--loader']))));
});

ProductName.schema = {
  title: 'editor.productName.title',
  description: 'editor.productName.description',
  type: 'object',
  properties: {
    showBrandName: {
      type: 'boolean',
      title: 'editor.productName.showBrandName.title',
      "default": false,
      isLayout: true
    },
    showSku: {
      type: 'boolean',
      title: 'editor.productName.showSku.title',
      "default": false,
      isLayout: true
    },
    showProductReference: {
      type: 'boolean',
      title: 'editor.productName.showProductReference.title',
      "default": false,
      isLayout: true
    }
  }
};
exports["default"] = ProductName;